// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'

import Vue from 'vue'
import Vuex from 'vuex'

import App from '@/App'
import router from '@/router'
import store from '@/vuex/store'

import VueClipboard from 'vue-clipboard2'

import AlertAlert from 'vue-alert-alert'

Vue.config.productionTip = false

Vue.use(Vuex)
Vue.use(VueClipboard)
Vue.use(AlertAlert)
/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  components: { App },
  template: '<App/>',
})
